export default {
    adobeOnPageLoad: {
        pageNameHome: "Adobe Carsaver home page tag",
        pageNameGarage: "Adobe Carsaver garage page tag",
        toolName: "but-at-home",
        countryCode: "US",
        languageCode: "en",
    },
    googleOnPageLoad: {
        googleEventName: "nissan-bah-TrackPageLoad",
        googlePropName: "nissan-partner-tagging",
        pageNameHome: "Google Carsaver home page tag",
        pageNameGarage: "Google Carsaver garage page tag",
        toolName: "buy-at-home",
        languageCode: "en",
        countryCode: "us",
    },
};
